import dayjs, { Dayjs, ManipulateType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const frontDateFormat = 'DD.MM.YYYY';
export const backDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';

export type DateManagerArg = Dayjs | string | number | Date;

// TODO: Выпилить moment и перейти на dayjs + DateManager
export class DateManager {
  private _dayjsDate: Dayjs;

  constructor(date: DateManagerArg, isUtc: boolean = false) {
    if (typeof date === 'string') {
      date = date.slice(0, -3);
    }

    if (typeof date !== 'string') {
      if (typeof date === 'number' || date instanceof Date) {
        this._dayjsDate = dayjs(date);
      } else {
        this._dayjsDate = date;
      }
    } else if (dayjs(date, frontDateFormat, true).isValid()) {
      this._dayjsDate = dayjs(date, frontDateFormat);
    } else if (dayjs(date, backDateFormat, true).isValid()) {
      this._dayjsDate = dayjs(date, backDateFormat);
    } else {
      throw new Error(`Неверный аргумент ${date}`);
    }

    if (isUtc) {
      this._dayjsDate = this._dayjsDate.utc();
    }
  }

  public static emptyWrapper(date?: DateManagerArg) {
    if (!date) {
      return null;
    }
    return new DateManager(date);
  }

  public get date() {
    return this._dayjsDate;
  }

  public get asDate() {
    return this._dayjsDate.toDate();
  }

  public get frontFormat() {
    return this._dayjsDate.format(frontDateFormat);
  }

  public get backFormat() {
    return this._dayjsDate.format(backDateFormat);
  }

  public subtract(qty: number, unit?: ManipulateType) {
    return this._dayjsDate.clone().subtract(qty, unit);
  }

  public get clone() {
    return this._dayjsDate.clone();
  }
}
